<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/salaryinfo/salaryaudit' }">工资审核管理</el-breadcrumb-item>
            <el-breadcrumb-item>绩效结果详情管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <!-- RefundSystem card header area -->
      <el-row :gutter="4">
        <el-col :span="3">
          <el-input size="small" clearable v-model="departmentName" placeholder="请输入中心/小中心/部门"></el-input>
        </el-col>
        <el-col :span="3">
          <el-input size="small" clearable v-model="trueName" placeholder="请输入姓名"></el-input>
        </el-col>
        <el-col :span="1">
          <el-button size="small" clearable icon="el-icon-search" @click="Search"></el-button>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
        </el-col>
        <el-col style="text-align:right;" :span="16">
          <!-- <el-button type="danger" class="danger" size="small" @click="updatePwd" plain>修改登录密码</el-button> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col
          style="text-align:left;padding-top: 10px;padding-bottom: 10px;width: 600px;padding-left: 20px;background-color: red;color: #fff;margin-top: 10px;margin-bottom: 10px;font-weight:bold;"
          :span="24">
          锐之旗 应领工资：
          <span>{{ moneys.shouldLed }}</span> 实发工资：
          <span>{{ moneys.receipt }}</span> 平均工资：
          <span>{{ moneys.average }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%" size="small">
            <el-table-column prop="工号" label="工号" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.工号 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="姓名" label="姓名" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.姓名 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="部门" label="部门">
              <template slot-scope="scope">
                <span>{{ scope.row.部门 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="应领工资" label="应发工资">
              <template slot-scope="scope">
                <span>{{ scope.row.应领工资 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="实发工资" label="实发工资">
              <template slot-scope="scope">
                <span>{{ scope.row.实发工资 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="最终实发工资" label="最终实发工资">
              <template slot-scope="scope">
                <span>{{ scope.row.最终实发工资 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="lookdetail(scope.$index, scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="text-align:right;" :span="24">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount" style="float:right"></el-pagination>
        </el-col>
      </el-row>
      <el-dialog width="50%" :title="dialogTitle" :visible.sync="dialogVisible" top="10px">
        <el-row>
          <el-col :span="12">
            <h1 style="font-size:20px">基本信息及考勤</h1>
          </el-col>
          <el-col :span="12">
            <h1 style="font-size:20px">工资信息</h1>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">序号</span>{{ SalaryResult.序号 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">固定工资</span>{{ SalaryResult.固定工资 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">姓名</span>{{ SalaryResult.姓名 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">通讯补助</span>{{ SalaryResult.通讯补助 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">工号</span>{{ SalaryResult.工号 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">交通补助</span>{{ SalaryResult.交通补助 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">中心</span>{{ SalaryResult.中心 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">子女教育基金</span>{{ SalaryResult.子女教育基金 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">小中心</span>{{ SalaryResult.小中心 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">生活补贴</span>{{ SalaryResult.生活补贴 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">部门</span>{{ SalaryResult.部门 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">月度绩效分数</span>{{ SalaryResult.月度绩效分数 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">中信银行卡号</span>{{ SalaryResult.中信银行卡号 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">绩效工资</span>{{ SalaryResult.绩效工资 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">身份证号</span>{{ SalaryResult.身份证号 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">季度绩效分数</span>{{ SalaryResult.季度绩效分数 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">岗位</span>{{ SalaryResult.岗位 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">季度绩效工资</span>{{ SalaryResult.季度绩效工资 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">职级</span>{{ SalaryResult.职级 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">消费提成</span>{{ SalaryResult.消费提成 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">薪级</span>{{ SalaryResult.薪级 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">奖励</span>{{ SalaryResult.奖励 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">档级</span>{{ SalaryResult.档级 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">续费提成</span>{{ SalaryResult.续费提成 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">社保与否</span>{{ SalaryResult.社保与否 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">项目提成</span>{{ SalaryResult.项目提成 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">入职时间</span>{{ SalaryResult.入职时间 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">其他</span>{{ SalaryResult.其他 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">异动时间</span>{{ SalaryResult.异动时间 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">应发工资</span>{{ SalaryResult.应领工资 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">离职时间</span>{{ SalaryResult.离职时间 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">考勤扣款</span>{{ SalaryResult.考勤扣款 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">实际出勤</span>{{ SalaryResult.实际出勤 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">其他扣款</span>{{ SalaryResult.其他扣款 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">计薪天数</span>{{ SalaryResult.计薪天数 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">社保扣款</span>{{ SalaryResult.社保扣款 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">节假日</span>{{ SalaryResult.节假日 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">公积金扣款</span>{{ SalaryResult.公积金扣款 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">应出勤</span>{{ SalaryResult.应出勤 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">应税工资</span>{{ SalaryResult.应税工资 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">未在职天数</span>{{ SalaryResult.未在职天数 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">代扣个税</span>{{ SalaryResult.代扣个税 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">病假</span>{{ SalaryResult.病假 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">实发工资</span>{{ SalaryResult.实发工资 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">事假</span>{{ SalaryResult.事假 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">个税差异</span>{{ SalaryResult.个税差异 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">带薪假</span>{{ SalaryResult.带薪假 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">餐卡发放金额</span>{{ SalaryResult.餐卡发放金额 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">迟到早退</span>{{ SalaryResult.迟到早退 }}
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">洋豆充值</span>{{ SalaryResult.洋豆充值 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;"></span>
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">罚款</span>{{ SalaryResult.罚款 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;"></span>
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">员工关爱基金</span>{{ SalaryResult.员工关爱基金 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;"></span>
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">最终实发工资</span>{{ SalaryResult.最终实发工资 }}
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;"></span>
          </el-col>
          <el-col :span="12">
            <span style="font-weight:bold;margin-right:6px;">备注</span>{{ SalaryResult.备注 }}
          </el-col>
        </el-row>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { getUrlKey } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetList, LookResult } from "../../until/ZeusApiSDK/Logic/SalaryInfoLogic";
import { GetKnowledgeContentDescry } from "../../until/ZeusApiSDK/Logic/WikiLogic";
export default {
  data() {
    return {
      pid: "", //传值
      departmentName: "", //中心/小中心/部门
      trueName: "", //真实姓名
      tableData: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      dialogTitle: "2020年9月绩效结果信息",
      dialogVisible: false,
      moneys: {
        shouldLed: "",
        receipt: "",
        average: ""
      },
      SalaryResult: {
      },
      formLabelWidth: "120px"
    };
  },
  //亚敏进入加载方法
  created() {
    this.pid = getUrlKey("pid");
    this.GetList();
  },
  methods: {
    //获取列表API
    GetList: async function () {
      this.loading = true;

      await GetList(
        this.pageIndex,
        this.pid,
        this.departmentName,
        this.trueName,
        this.pageSize,
        "0"
      ).then(res => {
        this.loading = false;
        this.tableData = res.Data.DataList;
        this.totalCount = res.Data.totalCount;
        this.moneys.shouldLed = res.Data.shouldLed;
        this.moneys.receipt = res.Data.receipt;
        this.moneys.average = res.Data.average;
        // console.log('resdata',res);
        if (res.Code == "200") {
          for (let i = 0; i < res.Data.DataList.length; i++) {
            // console.log('model',res.Data.DataList[i]);
            GetKnowledgeContentDescry(res.Data.DataList[i].应领工资).then(
              data => {
                res.Data.DataList[i].应领工资 = data;
              }
            );

            GetKnowledgeContentDescry(res.Data.DataList[i].实发工资).then(
              data => {
                res.Data.DataList[i].实发工资 = data;
              }
            );
            GetKnowledgeContentDescry(res.Data.DataList[i].最终实发工资).then(
              data => {
                res.Data.DataList[i].最终实发工资 = data;
              }
            );
          }
        }
        // this.tableData.map(item => {
        //   this.DESD(item);
        // });
      });
    },
    //方法区域
    handleSizeChange(val) {
      this.pid = getUrlKey("pid");
      this.pageSize = val;
      this.GetList();
    },
    handleCurrentChange(val) {
      this.pid = getUrlKey("pid");
      this.pageIndex = val;
      this.GetList();
    },
    //搜索
    Search: function () {
      this.pid = getUrlKey("pid");
      this.GetList();
    },
    //刷新页面
    Refresh: function () {
      this.pid = getUrlKey("pid");
      this.GetList();
    },
    //打开密码输入页面
    updatePwd: function () {
      this.dialogVisible = true;
    },
    //保存密码
    savePwd: function () {
      console.log("this.pass", this.pass);
    },

    lookdetail: function (index, row) {
      this.dialogVisible = true;
      LookResult(row.Id).then(res => {
        if (res.Code == "200") {

          this.SalaryResult = res.Data;
          this.dialogTitle = res.Data.公司;
          this.SalaryResult.固定工资 = GetKnowledgeContentDescry(this.SalaryResult.固定工资).then(
            data => {
              this.SalaryResult.固定工资 = data;
            }
          );
          this.SalaryResult.通讯补助 = GetKnowledgeContentDescry(this.SalaryResult.通讯补助).then(
            data => {
              this.SalaryResult.通讯补助 = data;
            }
          );
          this.SalaryResult.交通补助 = GetKnowledgeContentDescry(this.SalaryResult.交通补助).then(
            data => {
              this.SalaryResult.交通补助 = data;
            }
          );
          this.SalaryResult.子女教育基金 = GetKnowledgeContentDescry(this.SalaryResult.子女教育基金).then(
            data => {
              this.SalaryResult.子女教育基金 = data;
            }
          );
          this.SalaryResult.生活补贴 = GetKnowledgeContentDescry(this.SalaryResult.生活补贴).then(
            data => {
              this.SalaryResult.生活补贴 = data;
            }
          );
          this.SalaryResult.绩效工资 = GetKnowledgeContentDescry(this.SalaryResult.绩效工资).then(
            data => {
              this.SalaryResult.绩效工资 = data;
            }
          );
          this.SalaryResult.季度绩效工资 = GetKnowledgeContentDescry(this.SalaryResult.季度绩效工资).then(
            data => {
              this.SalaryResult.季度绩效工资 = data;
            }
          );
          this.SalaryResult.消费提成 = GetKnowledgeContentDescry(this.SalaryResult.消费提成).then(
            data => {
              this.SalaryResult.消费提成 = data;
            }
          );
          this.SalaryResult.奖励 = GetKnowledgeContentDescry(this.SalaryResult.奖励).then(
            data => {
              this.SalaryResult.奖励 = data;
            }
          );
          this.SalaryResult.续费提成 = GetKnowledgeContentDescry(this.SalaryResult.续费提成).then(
            data => {
              this.SalaryResult.续费提成 = data;
            }
          );
          this.SalaryResult.项目提成 = GetKnowledgeContentDescry(this.SalaryResult.项目提成).then(
            data => {
              this.SalaryResult.项目提成 = data;
            }
          );
          this.SalaryResult.应领工资 = GetKnowledgeContentDescry(this.SalaryResult.应领工资).then(
            data => {
              this.SalaryResult.应领工资 = data;
            }
          );
          this.SalaryResult.应税工资 = GetKnowledgeContentDescry(this.SalaryResult.应税工资).then(
            data => {
              this.SalaryResult.应税工资 = data;
            }
          );
          this.SalaryResult.实发工资 = GetKnowledgeContentDescry(this.SalaryResult.实发工资).then(
            data => {
              this.SalaryResult.实发工资 = data;
            }
          );
          this.SalaryResult.最终实发工资 = GetKnowledgeContentDescry(this.SalaryResult.最终实发工资).then(
            data => {
              this.SalaryResult.最终实发工资 = data;
            }
          );
        }
      }),
        // 打开弹窗
        this.openDialog();
      // 点击取消 -> 弹窗清空
    },
    //查看详情
    // lookdetail: function(data) {
    //   this.dialogVisible = true;
    // }
  }
};
</script>